import React, { useContext } from "react";
import toast from "react-hot-toast";
import { Context } from "../../context/Context";
import { handleImageCopy, handleImageDownload } from "../../utils/export.utils";

export default function Share({ txt, url }) {
  const { codeExport,state } = useContext(Context);
  return (
    <div className="mt-5 w-full">
      <span className="text-sm text-gray-600 font-medium  inline-block">
        {txt}
      </span>
      <br />
      <div className="grid grid-cols-4 gap-3 w-full mt-3">
        <button
          onClick={async () => {
            let copyHandler = handleImageCopy(codeExport.imageFile);
            toast.promise(copyHandler, {
              loading: "Copying...",
              success: "Copied",
              error: "Error while copying image",
            });
            await copyHandler;
          }}
          className="hover:shadow-lg w-12 h-12  rounded-md text-gray-400  focus:border-opacity-0 focus:bg-indigo-600 focus:ring-2 ring-indigo-300 focus:text-white border   p-2 cursor-pointer  outline-none transition transition-duration-300 ease-out "
        >
          <div className="w-full h-full ri-file-copy-fill text-xl flex items-center justify-center "></div>
        </button>
        {!url && (
          <button onClick={()=>handleImageDownload(codeExport.imageUrl,state.fileName.split(".")[0]===''?'untitled':state.fileName.split(".")[0]+'.png')} className="hover:shadow-lg w-12 h-12  rounded-md text-gray-400 focus:border-opacity-0 focus:bg-indigo-600 focus:ring-2 ring-indigo-300 focus:text-white border   p-2 cursor-pointer  outline-none transition transition-duration-300 ease-out ">
            <div className="w-full h-full ri-download-2-fill text-xl flex items-center justify-center "></div>
          </button>
        )}
      </div>
    </div>
  );
}
